import React, { useEffect, useState, useRef } from "react";
import { styled } from "@mui/material/styles";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ProfileImg from "../../icons/profile_img.png";

import {
  ButtonBase,
  Grid,
  Typography as MuiTypography,
  TableContainer,
  Paper,
  Avatar,
  Card,
  CardContent,
  CardActions,
  TableBody,
  TableHead,
  Table,
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
  Divider as MuiDivider,
  Box,
  Button,
} from "@mui/material";
import CafTerms from "../../users/user_details/CafTermsandConditions";
import CafFormSection from "./CafFormSection";
import useCafForm from "../../../hooks/useCafForm";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { spacing } from "@mui/system";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";
import CheckIcon from "@mui/icons-material/Check";
import useTenant from "../../../hooks/useTenant";

// const Divider = styled(MuiDivider)(spacing);

const StyledCard = styled(Card)`
  margin: 20px 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  @media print {
    margin: 0;
    box-shadow: none;
    overflow: visible !important;
    border: none;
  }
`;

// CSS to hide the button during print
const PrintButtonContainer = styled("div")`
  @media print {
    display: none;
  }
`;

const Typography = styled(MuiTypography)(spacing);

const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});

const TableCell = styled(MuiTableCell)`
  padding-top: 0;
  padding-bottom: 0;
`;

const TableRow = styled(MuiTableRow)`
  height: 42px;

  &:last-child th,
  &:last-child td {
    border-bottom: 0;
  }
`;

function CafPage(cafId) {
  const { getCafForm, cafForm, updateCafForm, isSubmitting, getKycDocumentPreview } = useCafForm();

  const componentRef = useRef();

  console.log(cafForm.fullName, "fulllll");

  let [searchParams, setSearchParams] = useSearchParams();

  const { state } = useLocation();

  const fetchData = async () => {
    await getCafForm(searchParams.get("id"));
  };

  useEffect(() => {
    if (searchParams && searchParams.get("id")) {
      fetchData();
    }
  }, [searchParams]);
  const [profileSrc, setProfileSrc] = useState(null);

  useEffect(() => {
    if (cafForm) {
      console.log(cafForm, "cafForm");
      const fetchLogo = async () => {
        await fetchTenantInvoiceLogo(cafForm?.msoId);
      };
      const fetchProfile = async () => {
        const fileName = cafForm.profileProofPath.split("/").pop();
        const profileUrl = await getKycDocumentPreview(cafForm?.cafId, fileName);
        if (profileUrl != null) {
          setProfileSrc(profileUrl);
        }
      };
      if (cafForm?.msoId) {
        fetchLogo();
      }
      if (cafForm.profileProofPath) {
        fetchProfile();
      }
    }
  }, [cafForm]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
    return Promise.resolve();
  }, []);

  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `Invoice_${cafForm?.cafId || ""}`,
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  const downloadPdf = async () => {
    const formElement = document.getElementById("caf_form_section");
    const termsContainer = document.getElementById("caf_terms_section");
    const buttonContainer = document.getElementById("printButtonContainer");

    if (!buttonContainer || !formElement || !termsContainer) {
      console.error("Elements not found");
      return;
    }

    buttonContainer.style.display = "none";

    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageHeightMM = 297;
      const pageWidthMM = 210;
      const marginMM = 10;
      const contentWidthMM = pageWidthMM - 2 * marginMM;
      // Convert mm to px (approximate for html2canvas)
      const mmToPx = 3.78;
      const pageHeightPx = pageHeightMM * mmToPx;
      const contentWidthPx = contentWidthMM * mmToPx;

      // --- PART 1: CAF Form Section (Slicing) ---
      const formCanvas = await html2canvas(formElement, { scale: 2 });
      const formImgData = formCanvas.toDataURL("image/png");
      const formImgHeight = (formCanvas.height * pageWidthMM) / formCanvas.width;

      let heightLeft = formImgHeight;
      let position = 0;

      pdf.addImage(formImgData, "PNG", 0, position, pageWidthMM, formImgHeight);
      heightLeft -= pageHeightMM;

      while (heightLeft >= 0) {
        position = heightLeft - formImgHeight;
        pdf.addPage();
        pdf.addImage(formImgData, "PNG", 0, position, pageWidthMM, formImgHeight);
        heightLeft -= pageHeightMM;
      }

      const termsRows = termsContainer.querySelectorAll("tr");

      // Create a temporary container for building pages
      const tempContainer = document.createElement("div");
      tempContainer.style.position = "absolute";
      tempContainer.style.top = "-9999px";
      tempContainer.style.left = "0";
      tempContainer.style.width = `${contentWidthPx}px`;
      tempContainer.style.backgroundColor = "white";
      tempContainer.style.padding = "20px"; // Simulating padding
      document.body.appendChild(tempContainer);

      // Helper to create a new page structure in temp container
      const createPageStructure = () => {
        tempContainer.innerHTML = ""; // Clear
        const header = document.createElement("div");
        header.innerHTML =
          '<h3 style="text-align:center; text-decoration:underline; margin-bottom:20px;">TERMS AND CONDITION</h3>';
        tempContainer.appendChild(header);

        const table = document.createElement("table");
        table.style.width = "100%";
        table.style.borderCollapse = "collapse";
        const tbody = document.createElement("tbody");
        table.appendChild(tbody);
        tempContainer.appendChild(table);
        return tbody;
      };

      let currentTbody = createPageStructure();

      // We will capture pages as we go
      for (let i = 0; i < termsRows.length; i++) {
        const row = termsRows[i].cloneNode(true);
        currentTbody.appendChild(row);
        if (tempContainer.offsetHeight > 1050) {
          currentTbody.removeChild(row);

          const canvas = await html2canvas(tempContainer, { scale: 2 });
          const imgData = canvas.toDataURL("image/png");
          pdf.addPage();
          pdf.addImage(
            imgData,
            "PNG",
            marginMM,
            marginMM,
            contentWidthMM,
            (canvas.height * contentWidthMM) / canvas.width,
          );
          // Start new page
          currentTbody = createPageStructure();
          // Re-add the row to the new page
          currentTbody.appendChild(row);
        }
      }
      // Capture the leftover content in the last page
      if (tempContainer.offsetHeight > 0) {
        const canvas = await html2canvas(tempContainer, { scale: 2 });
        const imgData = canvas.toDataURL("image/png");
        pdf.addPage();
        pdf.addImage(
          imgData,
          "PNG",
          marginMM,
          marginMM,
          contentWidthMM,
          (canvas.height * contentWidthMM) / canvas.width,
        );
      }

      // Cleanup
      document.body.removeChild(tempContainer);

      pdf.save(`CAF_${cafForm?.cafNumber}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      buttonContainer.style.display = "block";
    }
  };

  const [logoSrc, setLogoSrc] = useState(null);
  const { getTenantInvoiceLogo, tenantInvoiceLogo } = useTenant();

  const fetchTenantInvoiceLogo = async (tenantId) => {
    return await getTenantInvoiceLogo(tenantId);
  };

  useEffect(() => {
    if (tenantInvoiceLogo != null) {
      const imageUrl = URL.createObjectURL(tenantInvoiceLogo);
      setLogoSrc(imageUrl);
    }
  }, [tenantInvoiceLogo]);

  return (
    <>
      <Paper sx={{ backgroundColor: "#ffffff", padding: "16px", fontFamily: "Times New Roman" }}>
        <React.Fragment>
          <Grid container id="invoice_details">
            <Grid
              item
              xs={12}
              md={12}
              ref={componentRef}
              sx={{
                "@media print": {
                  display: "block",
                  overflow: "visible",
                },
              }}
            >
              <CafFormSection cafForm={cafForm} logoSrc={logoSrc} profileSrc={profileSrc} />

              <StyledCard
                id="caf_terms_section"
                sx={{
                  "@media print": {
                    pageBreakAfter: "always",
                  },
                }}
              >
                <CardContent>
                  <Typography
                    align="center"
                    variant="h5"
                    sx={{ textDecoration: "underline", mb: "20px" }}
                  >
                    TERMS AND CONDITION
                  </Typography>
                  <Card
                    mb={6}
                    sx={{
                      "@media print": {
                        boxShadow: "none",
                        overflow: "visible !important",
                      },
                    }}
                  >
                    <CafTerms cafForm={cafForm} />
                  </Card>
                </CardContent>
              </StyledCard>

              {/* Print Button using react-to-print */}

              <PrintButtonContainer id="printButtonContainer">
                <Grid container justifyContent="flex-end" spacing={2} sx={{ marginTop: 2 }}>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<PrintIcon />}
                      onClick={printFn}
                    >
                      Print Invoice
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="error"
                      startIcon={<DownloadIcon />}
                      onClick={downloadPdf}
                    >
                      Download PDF
                    </Button>
                  </Grid>
                </Grid>
              </PrintButtonContainer>
            </Grid>
          </Grid>
        </React.Fragment>
      </Paper>
    </>
  );
}

export default CafPage;
